import EkomApi from "../api/EkomApi";
import { useFetch } from './useFetch'

export const useCountSubmissions = () => {
  return useFetch<number>(EkomApi.getCountSubmissions);
};
